// mobile responsive
export const calendarDaySize =
  window.innerWidth < 540 ? Math.floor((window.innerWidth - 52) / 7) : 70;
